module.exports = __webpack_public_path__ + "static/media/pdf.1e86aab1.svg";